export default "__VITE_ASSET__4960914c__"